/**
 * <product-card-pictures>
 * Mobile-only product card image carousel using native scroll-snap.
 * Desktop hover-swap behavior is pure CSS (see product-card.css) — this component
 * only updates pagination dots based on which slide is in view.
 */
class ProductCardPictures extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-pcp-track]");
    if (!this.track) return;

    // Defensive: force initial scroll to slide 1. Avoids iOS Safari quirks
    // where RTL inheritance or layout-before-image-load leaves the carousel
    // pre-scrolled to slide 2 on mandatory snap.
    this.track.scrollLeft = 0;

    this.slides = Array.from(this.querySelectorAll("[data-pcp-slide]"));
    this.dots = Array.from(this.querySelectorAll("[data-pcp-dot]"));

    if (this.slides.length < 2 || this.dots.length === 0) return;

    this.controller = new AbortController();
    this.io = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.io.observe(slide));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.io?.disconnect();
  }

  handleIntersect(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const idx = this.slides.indexOf(entry.target);
      if (idx === -1) continue;
      this.setActive(idx);
    }
  }

  setActive(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle("swiper-pagination-bullet-active", i === index);
    });
  }
}

if (!window.customElements.get("product-card-pictures")) {
  window.customElements.define("product-card-pictures", ProductCardPictures);
}
